import { Component, OnInit, Input } from '@angular/core';
import { environment } from './../../../../../../environments/environment';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
  styleUrls: ['./header-top.component.scss']
})
export class HeaderTopComponent implements OnInit {

  @Input() cabecalho;
  @Input() titulo;
  @Input() qrcodeUrl = environment.homeUrl;
  logo: any;
  constructor() { }

  ngOnInit() {
    if(this.titulo != null && this.titulo != '') {
      this.formatTitle();
    }
    this.qrcodeUrl = this.cabecalho.qrcodeUrl;
    this.logo = this.cabecalho.logo || 'assets/images/brand_white_color.png';
  }

  formatTitle() {
    this.titulo = this.titulo.toUpperCase();
  }

}
